/**
 * @generated SignedSource<<b49de3bd868fa3bd3fef4830ec4ebd9d>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type useImageSearch_user$data = {
  readonly serviceId: string | null;
  readonly " $fragmentType": "useImageSearch_user";
};
export type useImageSearch_user$key = {
  readonly " $data"?: useImageSearch_user$data;
  readonly " $fragmentSpreads": FragmentRefs<"useImageSearch_user">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "useImageSearch_user",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "serviceId",
      "storageKey": null
    }
  ],
  "type": "User",
  "abstractKey": null
};

(node as any).hash = "3e1f5c76f8dfb78d8c26741debc50bf3";

export default node;
